
import {Link} from "react-router-dom";

import './Dashboard.scss';

import { CgList, CgUserAdd } from 'react-icons/cg';
import { GiSandsOfTime } from 'react-icons/gi';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import React, { useContext, useState } from 'react';
import MyContext from '../MyContext.jsx';
import { useHistory } from "react-router-dom/cjs/react-router-dom";


function attendanceCheck(userDetails, setStatus){

  const url2=`${process.env.REACT_APP_SSS}/api/getEmployeeAttendance`;
  var newdate=new Date();
  var year=newdate.getFullYear();
  var month=newdate.getMonth()+1;
  var day=newdate.getDate();
  var currdate=`${year}-${month}-${day}`
  $.ajax({
    url:url2,
    data:{
      sid:userDetails.user_details.sid,
      date:currdate,
    },
    type:"GET"
  }).done(function(return_data2){
    console.log(return_data2)
    if(return_data2.status=="Unmarked"){
      setStatus("Punch In?");
    }else if(return_data2.status=="Present"){
      if(return_data2.attendance.status=="IN"){
        setStatus("Punch Out?")
      }else if(return_data2.attendance.status=="OUT"){
        setStatus("Punched Out");
      }
    }
  }).fail(function(){
    alert("Network Error");
    history.replace('/');
  });
}
const Dashboard = () => {
  const userDetails = useContext(MyContext);
  const [status,setStatus] = useState('Punch In?');
  attendanceCheck(userDetails, setStatus);


  return (
    <div className="dashboard_page_container">
          <div className="yellow_shade11">
            <div className="desigtn_block">{userDetails.user_details.designation}</div>
            <div className="attendance">
                <Link to={status=="Punched Out"?"#":'/punchin'}>
                  <button className="att_btn">
                    <span className="att_front">
                      {status}
                    </span>
                  </button>
                </Link>
            </div>
          </div>
      <div className="menu_container">
        {/* Attendance , 2. Sales order,  3 New customer addition4. Performance,  5.Day Summary, 6. Route management, 7.   4. Day Plan. 8. 9. Outstating, 10. Lead, 11. Reports - My visit report, My attendance report, Sales report, Dealer wise report, Sales order reports, 12. Catalogue */}
       
        <Link to="/punchin" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/attendance.png"} height="100px;" />
        </Link>

        <Link to="/pricelist" className="single_menu_container">
          <img className="company_logo" src={window.project_path + "/dashboard/price_list.png"} height="100px;" />
        </Link>

        <Link to="/salesorders" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/salesorder.png"} height="100px;" />
        </Link>

        <Link to="/customers" className="single_menu_container">
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/customer.png"} height="100px;" />
        </Link>

        <Link to="/performanceDashboard" className="single_menu_container">
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/Perfomance.png"} height="100px;" />
        </Link>

        <Link to="/daySummary" className="single_menu_container">
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/daysummary.png"} height="100px;" />
        </Link>

        <Link to="/routes" className="single_menu_container" style={{
          display:userDetails.user_details.route_plan=='1'?"grid":"none"  }}>
          <img className="company_logo"  src={window.project_path+"/dashboard/route.png"} height="100px;" />
        </Link>

        <Link to="/dayplan"  style={{
          display:userDetails.user_details.route_plan=='1'?"grid":"none"  }} 
          className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/dayplan.png"} height="100px;" />
        </Link>


        <Link to="/outstandings" className="single_menu_container">
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/outstanding.png"} height="100px;" />
        </Link>

        <Link to="/leads" className="single_menu_container">
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/leads.png"} height="100px;" />
        </Link>

        {/* Leads */}
        
      
        <Link to="/reports" className="single_menu_container"  
        // style={{
        //  display:userDetails.user_details.dealer_report?"grid":
        //  userDetails.user_details.exe_report?"grid":
        //  userDetails.user_details.so_report?"grid":
        //  userDetails.user_details.category_sale_report?"grid":"none"}}
         >
          <img className="menu_icon_container"  src={window.project_path+"/dashboard/reports.png"} height="100px;" />
        </Link>

        <Link to="/travel/allowance" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/allowance.png"} height="100px;" />
        </Link>


        <Link to="/collections" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/collection.png"} height="100px;" />
        </Link>

        <Link to="/jointvisits" className="single_menu_container" style={{
          display:userDetails.user_details.joint_visit=='1'?"grid":"none"}}
          >
          <img className="company_logo"  src={window.project_path+"/dashboard/jointvisit.png"} height="100px;" />
        </Link>

        <Link to="/catalogue/attachment" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/CatalogueAttachment.png"} height="100px;" />
        </Link>

        <Link to="/salesreturn" className="single_menu_container">
          <img className="company_logo"  src={window.project_path+"/dashboard/sales_return.png"} height="100px;" />
        </Link>

      </div>
    
    </div>
  )
}

export default Dashboard;

